import { useEffect } from 'react';

import { useBlockRefresh } from 'src/hooks/useBlockRefresh';

interface UseNavigationBlockingReturn {
	shouldBlockNavigation: boolean;
	setShouldBlockNavigation: (value: boolean) => void;
}

export function useNavigationBlocking(isDirty: boolean): UseNavigationBlockingReturn {
	const { shouldBlockNavigation, setShouldBlockNavigation } = useBlockRefresh();

	useEffect(() => {
		setShouldBlockNavigation(isDirty);
	}, [isDirty, setShouldBlockNavigation]);

	return { shouldBlockNavigation, setShouldBlockNavigation };
}
